import Reveal from './ui/Reveal';
import { personas } from '../data/content';

export default function WhoItsFor() {
  return (
    <section className="alt" id="success">
      <div className="wrap">
        <Reveal className="center narrow">
          <span className="eyebrow">Who it&rsquo;s for</span>
          <h2 className="h-sec">
            Different backgrounds.
            <br />
            One LNG foundation.
          </h2>
        </Reveal>

        <div className="grid3 mt-l">
          {personas.map((persona, i) => (
            <Reveal key={persona.name} delay={i}>
              <article className="success">
                <div className="name">{persona.name}</div>
                <div className="meta">{persona.meta}</div>
                <div className="rule" />
                <div className="success-body">
                  <p>{persona.body}</p>
                </div>
                <div className="sstats">
                  {persona.stats.map((stat) => (
                    <div key={stat.num}>
                      <div className="num">{stat.num}</div>
                      <div className="cap">{stat.cap}</div>
                    </div>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
